// import RestNav from "./restNav";
import FoodScroll from "./foodScroll";
import RestCardsSec from "./restCardsSec";
import Footer from "../footer";
export default function RestPage() {

    return (
        <>
           
            <FoodScroll />
            <RestCardsSec />
            <Footer />
        </>
    )
}